module.exports = __webpack_public_path__ + "img/544.4ee84554.gif";